export const PAGE_MAX_WIDTH = 64.6875; // rem
export const BASE_FONT_SIZE: number = 16;
export const DEFAULT_CART_FONT_SIZE_NUMBER: number = 14;
export const DEFAULT_CART_FONT_SIZE_TEXT_IN_PX: string = `${DEFAULT_CART_FONT_SIZE_NUMBER}px`;
export const DEFAULT_CART_FONT_SIZE_TEXT_IN_REM: string = `${DEFAULT_CART_FONT_SIZE_NUMBER / BASE_FONT_SIZE}rem`;
